import axios from "axios";
import React, { useState, useEffect } from "react";
import { config } from "../../../config";
import { useForm } from "react-hook-form";
import Modal from "../../modal";
import M_Bedrijf_Bewerk from "./bewerk";
import { store } from "react-notifications-component";

import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();
function M_Bedrijf_Nieuw(props) {
    const [userOptions, setUserOptions] = useState([]);
    const [user, setUser] = useState({});
    useEffect(() => {
        axios
            .get(config.api + "/users")
            .then((res) => {
                let data = res.data;
                data = data.filter((x) => x.account_type === "company" || x.account_type === "recruit");

                let useropt = [];
                for (let x of data) {
                    useropt.push({ value: x.id, label: x.email });
                }
                setUserOptions(useropt);
            })
            .catch((err) => {
                //console.log(err)
            });
    }, []);

    const [message, setMessage] = useState(null);

    function onSubmit(values) {
        values["company_owner"] = user?.value;
        if (!values.company_name) {
            store.addNotification({
                title: "Aanmaken mislukt!",
                message: "Bedrijfsnaam mag niet leeg zijn!",
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true
                }
            });
            return;
        }
        if (!values.company_owner) {
            store.addNotification({
                title: "Aanmaken mislukt!",
                message: "Eigenaar mag niet leeg zijn!",
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true
                }
            });
            return;
        }

        console.log(values);

        if (values.company_name.includes("/")) {
            store.addNotification({
                title: "Aanmaken mislukt!",
                message: 'Bedrijfsnaam mag geen "/" bevatten!',
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true
                }
            });
            return;
        }
        axios
            .post(config.api + "/companies", values)
            .then(function (response) {
                props.search();
                setMessage(
                    <>
                        <p className="c-gray-700-70">
                            Aanmaken succesvol gelukt! bewerk het bedrijf
                            <Modal openButtonValue={"hier"} openButtonClasses="button link fw-700 c-blue-400 b-none pd-l-2">
                                <M_Bedrijf_Bewerk search={props.search} BedrijfID={response.data.id} />
                            </Modal>
                            .
                        </p>
                    </>
                );
            })
            .catch(function (error) {
                setMessage(<p className="c-red">Aanmaken is helaas mislukt, zorg dat alles correct is ingevuld.</p>);
            });
    }

    // company name
    // company desc

    const { register, handleSubmit } = useForm();

    let [claims] = useState(localStorage.getItem("claims") !== null ? JSON.parse(localStorage.getItem("claims")) : null);

    if (claims === null || claims.recruitment_privilege === false) {
        window.location.replace("/");
    } else
        return (
            <div className="container w-90 m-w-100 mr-v-10">
                {message}
                <h2 className="t-center c-gray-700-90 mr-v-5">BEDRIJF TOEVOEGEN</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input {...register("company_name")} name="company_name" type="text" className="text-input pd-2 t-8" placeholder="Bedrijf naam" />
                    <Select options={userOptions} isSearchable components={animatedComponents} onChange={setUser} isClearable placeholder="Kies eigenaar account" />
                    <input type="submit" className="button button-s b-blue-400 t-7 c-white fw-500 mr-t-10 mr-b-2" value="AANMAKEN" />
                </form>
            </div>
        );
}

export default M_Bedrijf_Nieuw;
